const useFormDisableFields = (locked, quotaRemaining, infiniteAnswers) => {
  const disableFields = !locked && quotaRemaining === 0 && !infiniteAnswers;
  return { disableFields };
};

export default useFormDisableFields;
